module.exports = __webpack_public_path__ + "img/logo2.ccd69bf3.png";